import React, { useState } from 'react';
import styles from '../Sales.module.scss';
//charts
import { Bar } from 'react-chartjs-2';
import { getColumnName } from '../Utils/dashboardUtils';
//Tr
import { useTranslation } from 'react-i18next';

export const SalesBarChart: React.FC<any> = ({ summaryData, periodFilter }) => {
  const { t } = useTranslation();

  const emptyChart = {
    labels: [],
    datasets: [
      // These two will be in the same stack.
      {
        stack: 'stack',
        label: 'premium',
        data: [],
        backgroundColor: '#E89E26',
        borderRadius: 2,
      },
      {
        stack: 'stack',
        label: 'tips',
        data: [],
        backgroundColor: '#0098FF',
        borderRadius: 2,
      },
      // {
      //   stack: 'stack',
      //   label: 'other',
      //   data: [],
      //   backgroundColor: '#999999',
      //   borderRadius: 2,
      // },
    ],
  };
  const [chartData, setChartData] = useState(emptyChart);
  React.useEffect(() => {
    summaryData.graph && formatData(summaryData.graph);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryData.graph]);

  const formatData = (data: any) => {
    const labels = () => {
      let foundData = false;
      const unfiltered = data.columns.map((column: any) => {
        if (
          !foundData &&
          column.premiums_sales.amount === 0 &&
          column.tips_sales.amount === 0
          // &&
          // column.others_sales.amount === 0
        ) {
          return null;
        } else {
          foundData = true;
          return getColumnName(column.name, periodFilter, t);
        }
      });
      var filtered = unfiltered.filter(function (el: any) {
        return el !== null;
      });
      return filtered;
    };
    const premiumsEarnings = () => {
      let foundData = false;
      const unfiltered = data.columns.map((column: any) => {
        if (
          !foundData &&
          column.premiums_sales.amount === 0 &&
          column.tips_sales.amount === 0
          // &&
          // column.others_sales.amount === 0
        ) {
          return null;
        } else {
          foundData = true;
          return (
            column.premiums_sales.amount /
            Math.pow(10, column.premiums_sales.decimals)
          );
        }
      });
      var filtered = unfiltered.filter(function (el: any) {
        return el !== null;
      });
      return filtered;
    };
    const tipsEarnings = () => {
      let foundData = false;
      const unfiltered = data.columns.map((column: any) => {
        if (
          !foundData &&
          column.premiums_sales.amount === 0 &&
          column.tips_sales.amount === 0
          //  &&
          // column.others_sales.amount === 0
        ) {
          return null;
        } else {
          foundData = true;
          return (
            column.tips_sales.amount / Math.pow(10, column.tips_sales.decimals)
          );
        }
      });

      var filtered = unfiltered.filter(function (el: any) {
        return el !== null;
      });
      return filtered;
    };
    // const othersEarnings = () => {
    //   let foundData = false;
    //   const unfiltered = data.columns.map((column: any) => {
    //     if (
    //       !foundData &&
    //       column.premiums_sales.amount === 0 &&
    //       column.tips_sales.amount === 0 &&
    //       column.others_sales.amount === 0
    //     ) {
    //       return null;
    //     } else {
    //       foundData = true;
    //       return (
    //         column.others_sales.amount /
    //         Math.pow(10, column.others_sales.decimals)
    //       );
    //     }
    //   });

    //   var filtered = unfiltered.filter(function (el: any) {
    //     return el !== null;
    //   });
    //   return filtered;
    // };

    const result = {
      labels: labels(),
      datasets: [
        {
          stack: 'stack',
          label: 'premium',
          data: premiumsEarnings(),
          backgroundColor: '#E89E26',
          borderRadius: 2,
        },
        {
          stack: 'stack',
          label: 'monedas',
          data: tipsEarnings(),
          backgroundColor: '#0098FF',
          borderRadius: 2,
        },
        // {
        //   stack: 'stack',
        //   label: 'other',
        //   data: othersEarnings(),
        //   backgroundColor: '#999999',
        //   borderRadius: 2,
        // },
      ],
    };
    setChartData(result);
  };

  const options = {
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        mode: 'point',
        intersect: false,
        callbacks: {
          label: function (tooltipItem: any) {
            var value = tooltipItem.dataset.data[tooltipItem.dataIndex];
            return value
              .toString()
              .replace('.', ',') // replace decimal point character with ,
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
          },
        },
      },
    },

    // barThickness: 30,
    maxBarThickness: 30,
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        offset: true,
        stacked: true,
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        ticks: {
          beginAtZero: true,
          maxTicksLimit: 10,
          // callback: function(value) {
          //   if (Number.isInteger(value)) {
          //     return value;
          //   }
          // },
          stepSize: 1,
          callback: function (value: string) {
            return value
              .toString()
              .replace('.', ',') // replace decimal point character with ,
              .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
          },
        },
      },
    },
  };

  return (
    <div>
      <Bar
        // @ts-ignore
        type={'bar'}
        data={chartData}
        // @ts-ignore
        options={options}
        className={styles.stackedChart}
      />
    </div>
  );
};
